// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"105":"7622c83690d1fffa6aaf","245":"aec2d684b0783bae6b4b","453":"d28710e59bdaa66e5505","739":"b0a558e991adc7afffa2"}[chunkId] + ".js";
};